const constants = {
  label: "หมวดสินค้า Scrape"
};

const paths = {
  index: "/remyndScrapeCategory"
};

export { constants, paths };
